import en from "./en.js";
import cn from "./zh_cn.js";
import fr from "./fr.js";

export default {
  cn,
  en,
  fr,
};
